import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useSkillsForPersona, useSkillsForSession } from '../../hooks/useSkills';
import { SkillBadge } from './SkillBadge';

interface SkillAttachmentListProps {
  entityType: 'persona' | 'session';
  entityId: string;
  onDetach?: (skillName: string) => void;
}

export const SkillAttachmentList: React.FC<SkillAttachmentListProps> = ({
  entityType,
  entityId,
  onDetach,
}) => {
  const { darkMode } = useTheme();

  const personaQuery = useSkillsForPersona(entityType === 'persona' ? entityId : '');
  const sessionQuery = useSkillsForSession(entityType === 'session' ? entityId : '');

  const query = entityType === 'persona' ? personaQuery : sessionQuery;
  const attachments = query.data ?? [];

  if (query.isLoading) {
    return <div className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Loading skills...</div>;
  }

  if (attachments.length === 0) {
    return (
      <div className={`text-xs ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>
        No skills attached
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-1.5">
      {attachments.map((a) => (
        <SkillBadge
          key={a.skill_name}
          name={a.skill_name}
          onRemove={onDetach ? () => onDetach(a.skill_name) : undefined}
        />
      ))}
    </div>
  );
};
